/*
 *   File : icons.js
 *   Author : https://evoqins.com
 *   Description : icon component
 *   Integrations : NA
 *   Version : 1.0.0
 */

import React from 'react';
import IcoMoon from 'react-icomoon'
import iconSet from '../Assets/icons/selection.json';
export default function Icon(props) {
  return (
    <IcoMoon iconSet={iconSet} {...props} />
  )
}